import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AppStateService {
  // Current site ID state management
  private _currentSiteId = signal<string | null>(null);
  readonly currentSiteId = this._currentSiteId.asReadonly();

  // For viewers - can switch between sites
  setViewerSite(siteId: string): void {
    this._currentSiteId.set(siteId);
  }

  // For admin users - set the current site context
  setCurrentSiteId(siteId: string | null): void {
    this._currentSiteId.set(siteId);
  }

  // Additional global state can be added here as needed
  // Example: UI preferences, theme state, etc.
}
